interface IndexItem {
  label: string;
  count: string;
  icon: string;
}

const items: IndexItem[] = [
  { label: '动作片', count: '2,856部', icon: 'ri-sword-line' },
  { label: '喜剧片', count: '1,942部', icon: 'ri-emotion-laugh-line' },
  { label: '爱情片', count: '1,673部', icon: 'ri-heart-line' },
  { label: '科幻片', count: '1,234部', icon: 'ri-rocket-line' },
  { label: '悬疑片', count: '1,508部', icon: 'ri-search-eye-line' },
  { label: '恐怖片', count: '987部', icon: 'ri-ghost-line' },
  { label: '国产剧', count: '3,421部', icon: 'ri-tv-line' },
  { label: '韩剧', count: '2,156部', icon: 'ri-global-line' },
  { label: '美剧', count: '1,890部', icon: 'ri-earth-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">影视索引</h2>
            <p className="text-sm text-foreground-600 mt-1">分类浏览 · 快速找到你想看的</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5 max-w-[900px] mx-auto">
            {items.map((item, i) => (
              <a
                key={i}
                href="#index"
                className="group flex items-center gap-3 bg-background-200 rounded-xl p-4 cursor-pointer transition-colors hover:bg-background-300 border border-background-200/60 hover:border-primary-500/30"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 shrink-0">
                  <i className={`${item.icon} text-primary-500 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.label}
                  </div>
                  <div className="text-xs text-foreground-600">{item.count}</div>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-600 shrink-0"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}